import { useEffect, useCallback } from 'react';
const TAB_KEY = 'Tab';
const focusableElementsSelector = 'a[href], button, textarea, input, select';
/**
 * Trap focus inside given node.
 */
export const useFocusTrap = ({ elementRef, enabled = true }) => {
    const handleKeyDown = useCallback((event) => {
        var _a;
        const { key } = event;
        if (key !== TAB_KEY) {
            return;
        }
        const focusableElementsList = Array.from(((_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(focusableElementsSelector)) || []);
        if (!focusableElementsList.length) {
            return;
        }
        const targetCandidate = focusableElementsList[event.shiftKey ? focusableElementsList.length - 1 : 0];
        if (!focusableElementsList.includes(document.activeElement)) {
            targetCandidate.focus();
            event.preventDefault();
            return;
        }
        const finalFocusable = focusableElementsList[event.shiftKey ? 0 : focusableElementsList.length - 1];
        const leavingFinalFocusable = finalFocusable === document.activeElement || elementRef.current === document.activeElement;
        if (!leavingFinalFocusable) {
            return;
        }
        event.preventDefault();
        targetCandidate.focus();
    }, [elementRef]);
    useEffect(() => {
        if (!enabled || !elementRef.current) {
            return;
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown, enabled, elementRef]);
};
